export default () => {
    const videoControl = document.querySelectorAll('.js-popup-video-control')
    const videoElement = document.querySelector('.js-popup-video')
    const videoOverlay = document.querySelector('.js-video-overlay')
    const videoClose = document.querySelector('.js-popup-video-close')

    function stopVideo() {
        videoOverlay.classList.remove('is-active')
        videoElement.pause()
        // Reset the current time to 0 and remove the src attribute 
        videoElement.currentTime = 0;
        videoElement.removeAttribute('src')
    }
    
    if (videoControl && videoControl.length > 0) {
        
        videoControl.forEach(control => {
            const videoSrc = control.getAttribute("data-video-id")
            
            control.addEventListener("click", (e) => {
                videoOverlay.classList.add('is-active')
                videoElement.setAttribute('src', videoSrc);
                const currentTime = control.getAttribute("data-video-current-time")
                if (currentTime) {
                    // Commenting out for now in case rhe funxtionality is returned at a later date.
                    // videoElement.currentTime = currentTime;
                }
                videoElement.play()
                e.preventDefault()
            })
        });

        if (videoClose) {
            videoClose.addEventListener("click", () => {
                stopVideo()
            })
        }

        document.addEventListener('keydown', (e) => {
            if(e.key === "Escape"){
                stopVideo()
            }
        })
    }
}